import * as React from 'react';
import Radium from 'radium';
import { Helmet } from 'react-helmet';
import { Col, Grid, Row } from 'react-bootstrap';

import AboutUs from './../components/about_us';
import Claim from './../components/claim';
import ContactForm from './../contact_form';
import ContactMembers from './../contactpage/members';
import FAQ from './../components/faq';
import GetAWorkshop from './../components/get_a_workshop';
import GetCardGame from './../components/get_card_game';
import WhatWeDo from './../components/what_we_do';
import Workshops from './../components/workshops';

@Radium
export default class Homepage extends React.Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>Stužák - studenti žákům</title>
        </Helmet>
        <Claim />
        <Row className="grey about-us" style={styles.contentRow}>
          <h2>Kdo jsme</h2>
          <Grid>
            <Row>
              <Col md={12}>
                <AboutUs />
              </Col>
            </Row>
          </Grid>
        </Row>
        <Row style={styles.contentRow}>
          <h2>Jsme Stužák</h2>
          <Grid>
            <Row>
              <Col md={8} mdOffset={2}>
                <WhatWeDo />
              </Col>
            </Row>
          </Grid>
        </Row>
        <Row className="grey" style={styles.contentRow}>
          <h2>Naše workshopy</h2>
          <Grid>
            <Row>
              <Col md={8} mdOffset={2}>
                <Workshops />
              </Col>
            </Row>
          </Grid>
        </Row>
        <Row style={styles.contentRow}>
          <h2>Tři kroky k workshopu</h2>
          <Grid>
            <Row>
              <Col md={8} mdOffset={2}>
                <GetAWorkshop />
              </Col>
            </Row>
          </Grid>
        </Row>
        <Row className="grey" style={styles.contentRow}>
          <h2>Karetní hra To letí století</h2>
          <Grid>
            <Row>
              <Col md={8} mdOffset={2}>
                <GetCardGame />
              </Col>
            </Row>
          </Grid>
        </Row>
        <Row className="faq" style={styles.contentRow}>
          <Grid>
            <Row>
              <Col md={8} mdOffset={2}>
                <h2>Časté otázky</h2>
                <FAQ />
              </Col>
            </Row>
          </Grid>
        </Row>
        <Row className="contacts grey" style={styles.contentRow}>
          <Grid>
            <Row>
              <Col md={8} mdOffset={2}>
                <h2>Kontaktujte nás</h2>
                <ContactMembers />
                <ContactForm />
              </Col>
            </Row>
          </Grid>
        </Row>
      </div>
    );
  }
}

const styles = {
  contentRow: {
    padding: '30px 15px 60px 15px'
  }
};



// WEBPACK FOOTER //
// ./src/browser/Feature/homepage/index.jsx